/**
 * Booking-flow-v2 iframe (brand=internal) — blijvend pad voor diensten die
 * naar partners gaan. Gedrag identiek aan de oude NieuweAanvraagPage.
 */
export function BookingFlowFrame({ onBack }: { onBack: () => void }) {
  return (
    <div className="flex-1 flex flex-col min-h-0">
      <div className="px-4 py-2 border-b border-slate-200 bg-white">
        <button onClick={onBack} className="text-sm text-indigo-600 hover:underline">
          ← Terug naar dienstkeuze
        </button>
      </div>
      <iframe
        src="https://intern-v2.cincocleaning.com"
        className="flex-1 w-full border-0"
        title="Nieuwe aanvraag"
      />
    </div>
  )
}
